import React from 'react';
import { ArrowUp, Github, Linkedin, Mail } from 'lucide-react';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-main">
          <div className="footer-brand">
            <div className="header-logo">
              <span>ISMAIL ESSAGAR</span>
            </div>
            <p className="text-body footer-tagline">
              Data Scientist &  Engineer
            </p>
          </div>

          <div className="footer-links">
            <div className="footer-section">
              <h4 className="label-small footer-title">NAVIGATION</h4>
              <nav className="footer-nav">
                <a href="#home" className="footer-link text-body">Home</a>
                <a href="#about" className="footer-link text-body">About</a>
                <a href="#experience" className="footer-link text-body">Experience</a>
                <a href="#projects" className="footer-link text-body">Projects</a>
                <a href="#skills" className="footer-link text-body">Skills</a>
                <a href="#contact" className="footer-link text-body">Contact</a>
              </nav>
            </div>

            <div className="footer-section">
              <h4 className="label-small footer-title">CONNECT</h4>
              <div className="footer-social">
                <a 
                  href="mailto:essagarismail@gmail.com" 
                  className="footer-social-link"
                  title="Email"
                >
                  <Mail size={20} />
                  <span className="text-body">Email</span>
                </a>
                <a 
                  href="https://linkedin.com/in/ismail-essagar" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="footer-social-link"
                  title="LinkedIn"
                >
                  <Linkedin size={20} />
                  <span className="text-body">LinkedIn</span>
                </a>
                <a 
                  href="https://github.com/ismailsg" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="footer-social-link"
                  title="GitHub"
                >
                  <Github size={20} />
                  <span className="text-body">GitHub</span>
                </a>
              </div>
            </div>

            <div className="footer-section">
              <h4 className="label-small footer-title">SPECIALTIES</h4>
              <div className="footer-specialties">
                <span className="text-body">Machine Learning</span>
                <span className="text-body">Data Engineering</span>
                <span className="text-body">Deep Learning</span>
                <span className="text-body">NLP</span>
                <span className="text-body">Computer Vision</span>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="text-body footer-copyright">
              © {currentYear} Ismail Essagar. All rights reserved.
            </p>
            
            <div className="footer-bottom-links">
              <span className="label-small">Built with React & FastAPI</span>
              <span className="label-small">•</span>
              <span className="label-small">France</span>
            </div>

            <button onClick={scrollToTop} className="back-to-top">
              <ArrowUp size={20} />
              <span className="label-small">BACK TO TOP</span>
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;